module.exports = __webpack_public_path__ + "assets/img/tiyan1.0eaf7c20.png";